<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <label class="sa-accordion-label">
                        <span>Parametri Vitali</span>
                        <!--  class="sa-flexbox-body-title" -->
                        <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnNuovoParametroVitaleHidden" @click="onClickNuovoParametroVitale" class="mb-2">
                            <font-awesome-icon icon="plus"> </font-awesome-icon>
                            Aggiungi
                        </b-button>
                    </label>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table sa-card-border">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row" v-if="!isViewMode">
                                <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Parametro" @click="onClickAggiornaParametroVitale(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Parametro" variant="outline-danger" @click="onDeleteParametroVitale(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <rsa-parametri-vitali-edit-modal-component ref="cmpRsaParametriVitaliModalEditComponent" :id-accettazione="idAccettazione" @afterSaveSuccess="onAfterSaveSuccessParametroVitale" @onClose="loadData" @onDelete="onDelete"> </rsa-parametri-vitali-edit-modal-component>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaParametriVitaliEditModalComponent from "./RsaParametriVitaliEditModalComponent.vue";
import moment from "moment";

export default {
    props: {
        jsonDataAccettazione: { type: Object },
        utente: { type: Object },
        isViewMode: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
        /* idAccettazione: {
          immediate: true,
          handler(newVal) {
              if (newVal) {
                  this.loadData();
              }
          },
      }, */
    },
    mixins: [UtilityMixin],
    components: { RsaParametriVitaliEditModalComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            btnNuovoParametroVitaleHidden: false,
            pathResource: "",
            linkedit: "/",
            idAccettazione: null,
            filtroParametroVitale: {},
            showModalLoading: false,
            fields: [
                {
                    label: "",
                    key: "index",
                },
                {
                    label: "Data Esecuzione",
                    key: "dataEsecuzione",
                    sortable: true,
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
                },
                {
                    label: "Ora Esecuzione",
                    key: "oraEsecuzione",
                    sortable: true,
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("hh/mm/ss");
                        } else {
                            return "-----";
                        }
                    },
                },

                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                    /* thStyle: () => (this.isViewMode ? "display: none" : ""), */
                },
            ],
        };
    },
    mounted() {},

    methods: {
        setId(id) {
            let me = this;
            me.idAccettazione = id;
            me.filtroParametroVitale = { idAccettazione: id };
            me.loadData();
        },

        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (!me.idAccettazione) {
                console.warn("Non carica il load data: idAccettazione non disponibile");
                return;
            }
            if (sessionStorage["filtroParametroVitale"]) {
                me.filtroParametroVitale = JSON.parse(sessionStorage["filtroParametroVitale"]);
            }
            me.filtroParametroVitale = {
                ...me.filtroParametroVitale,
                page: me.currentPage,
                forPage: me.perPage,
                idAccettazione: me.idAccettazione,
            };
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroParametroVitale, me.loadDataSuccess, me.loadDataError);
            this.showModalLoading = true;
        },

        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            this.showModalLoading = true;
        },
        loadDataError(response) {
            console.log(response);
        },

        onClickAggiornaParametroVitale(item) {
            this.$refs.cmpRsaParametriVitaliModalEditComponent.show(item);
        },

        onDeleteParametroVitale(item) {
            let me = this;
            me.$refs.cmpRsaParametriVitaliModalEditComponent.onDeleteParametroVitale(item);
        },

        onClickNuovoParametroVitale() {
            let me = this;
            me.$refs.cmpRsaParametriVitaliModalEditComponent.show({
                id: null,
                idAccettazione: me.idAccettazione,
            });
        },
        /* saveSuccessResponse(response) {
            let me = this;
            me.$emit("sucessRestCall", response);
            me.$emit("onAfterSave");
            me.loadData();
        },
        saveErrorResponse(response) {
            console.log(response.response.data);
            let me = this;
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                me.$bvToast.toast("Errore nel salvataggio" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        }, */
        onAfterSaveSuccessParametroVitale() {
            this.loadData();
        },
        onDelete() {
            this.loadData();
        },
    },
};
</script>
